import React, { FC, ReactElement } from "react";
import { useSelector } from "react-redux";

import Checkbox, { CheckboxProps } from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";

import { useDispatch } from "../../store";
import { ReduxFormProps } from "../../types/ReduxForm";

type ReduxOptionalSwitchProps = CheckboxProps &
  ReduxFormProps & {
    label: string;
    title?: string;
  };

const OptionalSwitch: FC<ReduxOptionalSwitchProps> = ({
  path,
  setter,
  getter,
  label,
  title,
  ...props
}): ReactElement => {
  const value = useSelector(getter(path, undefined)) as boolean;
  const dispatch = useDispatch();
  if (!title) {
    title =
      value === true
        ? "The setting will be applied and override its Global counterpart"
        : value === false
          ? "The setting will be omitted and override its Global counterpart"
          : "The setting will inherit its value from its Global counterpart.";
  }

  return (
    <Tooltip title={title}>
      <FormControlLabel
        control={
          <Checkbox
            {...props}
            checked={!!value}
            color="primary"
            indeterminate={value === undefined}
            onChange={(): void => {
              dispatch(
                setter({
                  path,
                  value:
                    value === undefined
                      ? true
                      : value === true
                        ? false
                        : undefined,
                }),
              );
            }}
          />
        }
        label={label}
      />
    </Tooltip>
  );
};

export default OptionalSwitch;
